import $ from 'jquery';

const parseISO8601 = ISOduration => {
    const regex =
        /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
    const matches = ISOduration.match(regex);
    let hours = matches[6] === undefined ? 0 : matches[6];
    let minutes = matches[7] === undefined ? '00' : matches[7];
    let seconds = matches[8] === undefined ? '00' : matches[8];

    hours = hours.length === 1 ? `0${hours}` : hours;
    minutes = minutes.length === 1 ? `0${minutes}` : minutes;
    seconds = seconds.length === 1 ? `0${seconds}` : seconds;

    let duration = hours === 0 ? '' : `${hours}:`;
    duration += `${minutes}:${seconds}`;

    return duration;
};

const playVideo = ($item, firstLoad) => {
    if ($item.closest('li').hasClass('active')) {
        return;
    }

    if (firstLoad) {
        const $videoSwitcher = $('.js-video-switcher');
        const $videoPlayer = $videoSwitcher.find('.js-video-player');
        const $slider = $videoPlayer.find('.video-player-slider .inner');
        const $currentSlide = $slider.find('.slick-current');
        $currentSlide.addClass('slick-main-active');
    }

    const { videoId } = $item.find('.js-item-duration')[0].dataset;
    $item.closest('li').addClass('active');

    const $player = $item.closest('.js-video-player');
    $player
        .find('.js-video-player-main iframe')
        .attr(
            'src',
            `https://www.youtube.com/embed/${videoId}?showinfo=0&rel=0`
        );
    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    $player.find('.js-video-title').text(
        truncateText($item.find('.js-item-title').text(), 90)
    );
    $player
        .find('.js-video-description')
        .html(truncateText($item.find('.js-item-description').html(), 90));
    $player
        .find('.js-video-duration')
        .attr('data-video-id', $item.data('video-id'))
        .text($item.find('.js-item-duration')[0].innerText);
};

const populateList = (list, $videoPlayer) => {
    // const $listDom = $videoPlayer.find('.js-video-player-sidebar');
    const template = $('.js-sidebar-item-template').html();
    const $slider = $videoPlayer.find('.video-player-slider .inner');

    // if ($listDom.length <= 0) return;
    if (list.length <= 0) {
        return;
    }

    let firstTrigger = false;
    // $listDom.html('');
    for (let i = 0; i < list.length; i += 1) {
        const $item = $(template).clone();
        $item
            .find('.js-video-player-item')
            .attr('data-video-id', list[i].videoId);
        $item
            .find('.js-item-thumb')
            .css('backgroundImage', `url(${list[i].thumbUrl})`);
        $item.find('.js-item-title').text(list[i].title);
        $item.find('.js-item-description').html(list[i].description);
        $item.find('.js-item-duration').attr('data-video-id', list[i].videoId);

        $slider.slick('slickAdd', $item);

        if (!firstTrigger) {
            playVideo($item, true);
            firstTrigger = true;
        }
    }

    const $videoSwitcher = $('.js-video-switcher');

    $videoSwitcher.on('click', '.js-video-player-item', function() {
        const $selectedSlide = $slider.find('.slick-main-active');
        $selectedSlide.removeClass('slick-main-active');
        $(this).addClass('slick-main-active');
        playVideo($(this), false);
        // if (window.innerWidth <= 1024) {
        //     const sliderToScrollId = $(this).closest('.c-tabs')
        //         .attr('id');
        //     const sliderToScroll = document.getElementById(sliderToScrollId);
        //     const sliderToScrollPosition =
        //         sliderToScroll.getBoundingClientRect();
        //     window.scrollTo({
        //         top: sliderToScrollPosition.top + window.scrollY - 24,
        //         behavior: 'smooth',
        //     });
        // }
    });

    // update tab title and show
    $videoPlayer
        .closest('.js-video-switcher')
        .find(`.js-tab-item[data='${list[0].playlistId}']`)
        .addClass('visible');
    // comment this for now, seem like YT change the API, also update select for mobile
    // .find('h3')
    // .text(list[0].channelTitle);

    $slider.on('wheel', function(e) {
        e.preventDefault();

        if (e.originalEvent.deltaY > 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    });

    const prevButton = $videoPlayer.find('.prev-button');
    const nextButton = $videoPlayer.find('.next-button');

    prevButton.on('click', () => {
        return $slider.slick('slickPrev');
    });
    nextButton.on('click', () => {
        return $slider.slick('slickNext');
    });

    if (
        (list.length <= 5 && window.innerWidth > 768) ||
        (list.length <= 2 && window.innerWidth <= 768)
    ) {
        prevButton.addClass('btn-disabled');
        nextButton.addClass('btn-disabled');
    }
};

const handleJSONError = error => {
    console.error(error);
};

const mapToVideoList = item => {
    const { snippet } = item;
    const thumbUrl = snippet.thumbnails ? snippet.thumbnails.high.url : '';

    return {
        thumbUrl,
        playlistId: snippet.playlistId,
        channelTitle: snippet.channelTitle,
        videoId: snippet.resourceId.videoId,
        title: snippet.title,
        description: snippet.description,
    };
};

const handleJSONResponseVideo = response => {
    if (!response.items || !response.items.length) {
        return;
    }

    response.items.map(item => {
        return $(
            `.js-item-duration[data-video-id='${item.id}'], .js-video-duration[data-video-id='${item.id}']`
        ).text(parseISO8601(item.contentDetails.duration));
    }
    );
};

const getVideoDuration = (ids, key) => {
    const apiUrl = 'https://www.googleapis.com/youtube/v3/videos';
    const options = {
        part: 'contentDetails',
        key,
        id: ids.join(','),
    };

    $.getJSON(apiUrl, options)
        .done(handleJSONResponseVideo.bind(null))
        .fail(handleJSONError);
};

const handleJSONResponsePlayList = ({ key, $videoPlayer }, response) => {
    if (!response.items || !response.items.length) {
        return;
    }

    getVideoDuration(
        response.items.map(item => {
            return item.snippet.resourceId.videoId;
        }),
        key
    );
    populateList(response.items.map(mapToVideoList), $videoPlayer);
};

const fetchData = (apiUrl, $videoPlayer, key) => {
    const options = {
        part: 'snippet',
        key,
        // maxResults: $videoPlayer.data('max-item'),
        maxResults: 50,
        playlistId: $videoPlayer.data('playlist-id'),
    };

    $.getJSON(apiUrl, options)
        .done(handleJSONResponsePlayList.bind(null, { key, $videoPlayer }))
        .fail(handleJSONError);
};

const mobileFilter = () => {
    const $mobileSelect = $('.js-mobile-tab-selection');
    const $tabItem = $('.js-tabs');
    const $customSelect = $('.custom-select-opener span');
    let newSelection = '';

    if ($mobileSelect.length <= 0) {
        return;
    }
    if ($tabItem.length <= 0) {
        return;
    }

    $mobileSelect.change(function() {
        const $opt = $(this);
        const $tab = $opt
            .closest('.js-video-switcher')
            .find(`.js-tab-item[data="${$opt.val()}"]:not(.active)`);

        if ($tab.length === 1) {
            $tab.click();
        }
        newSelection = $tab.find('.tab-btn')[0].innerText;
    });

    // change selection on tab clicked
    $tabItem.on('click', '.js-tab-item', function() {
        const $item = $(this);
        const playlistKey = $item.attr('data');
        $item
            .closest('.js-video-switcher')
            .find('.js-mobile-tab-selection')
            .val(playlistKey);
        // Here we reset all other tab's iframe src to stop them from playing
        $item
            .closest('.js-video-switcher')
            .find(
                `.js-video-player:not([data-playlist-id="${playlistKey}"]) iframe`
            )
            .each(function() {
                const currentSrc = $(this).attr('src');
                $(this).attr('src', '');
                $(this).attr('src', currentSrc);
            });

        const $videoSwitcher = $('.js-video-switcher');
        const $videoPlayer = $videoSwitcher.find('.js-video-player');
        const $sidebar = $videoPlayer.find('.video-player-sidebar');
        const $slider = $videoPlayer.find('.video-player-slider .inner');
        $sidebar.css('opacity', '0');
        setTimeout(() => {
            $slider.slick('refresh');
            $sidebar.css('opacity', '1');
            if (newSelection) {
                const newItem = $item
                    .closest('.js-video-switcher')
                    .find($customSelect)
                    .val(playlistKey);
                newItem.text(newSelection);
            } else {
                $customSelect.text(
                    $tabItem.find('.js-tab-item.active button')[0].innerText
                );
            }
        }, 1000);
    });

    // trigger click for first time because tabs has function to retrieve url and cookie
    $tabItem.find('.js-tab-item.active').click();
};

const initVideoSwitcher = () => {
    const apiUrl = 'https://www.googleapis.com/youtube/v3/playlistItems';
    const $videoSwitcher = $('.js-video-switcher');
    const $videoPlayer = $videoSwitcher.find('.js-video-player');

    if ($videoSwitcher.length <= 0) {
        return;
    }

    mobileFilter();

    $videoPlayer.each(function() {
        fetchData(apiUrl, $(this), $videoSwitcher.data('key'));
    });
};

$(() => {
    initVideoSwitcher();
});
